// src/helper/isEmptyTime.js
/*
 * Перевіряє, що значення часу порожнє.
 * Порожнім вважаємо: null, undefined, '', '00:00', '00:00:00'.
 * @param {(string|null|undefined)} v
 * @returns {boolean}
 */
export default function isEmptyTime(v) {
	if (v == null) return true;
	const s = String(v).trim();
	return s === '' || s === '00:00' || s === '00:00:00';
}
